import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { Dialog, Carousel } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import MediaDetail from './MediaDetail'
import { Detail, Media } from './types'

const MediaViewer = styled.div<{ mode: string }>`
  flex: none;
  width: 660px;
  height: 460px;
  border-right: 1px solid ${({ mode }) => sys[mode].common.divider[100]};
`

const ContentWrapper = styled.div`
  display: flex;
  margin-left: 20px;
`

type MediaModalProps = {
  title: string
  open: boolean
  onClose: () => void
  detail: Detail
  medias: Media[]
}

const MediaModal = ({ title, open, onClose, detail, medias }: MediaModalProps) => {
  const displayTheme = useDisplayTheme()
  const mediasWithFallbackUrls = medias.map((media) => ({
    ...media,
    fallback: {
      originUrl: detail.postUrl,
      infoUrl: 'https://help.quid.com/articles/8240236#h_24b221c46b'
    }
  }))

  return (
    <Dialog mode={displayTheme} open={open} onClose={onClose} disableBackdropClick width="1001px">
      <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
      <ContentWrapper>
        <MediaViewer mode={displayTheme}>
          <Carousel mode={displayTheme} slides={mediasWithFallbackUrls} />
        </MediaViewer>
        <Dialog.DialogContent height="460px" width="320px">
          <MediaDetail data={detail} />
        </Dialog.DialogContent>
      </ContentWrapper>
      <Dialog.DialogActions />
    </Dialog>
  )
}

export default MediaModal
